import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { GeckoFileCategory, RolodexEntryType } from 'types'

import {
  calculateTotalDocuments,
  computeCategoryMetrics,
} from './helpers/computeCategoryMetrics'

export interface DocumentCategoryMetric {
  category: GeckoFileCategory
  categoryLabel: string
  count: number
  reportIds: ReadonlyArray<string>
}

export interface DataHealthMetrics {
  categoryMetrics: ReadonlyArray<DocumentCategoryMetric>
  totalDocuments: number
  isLoading: boolean
  hasEverLoaded: boolean
}

export function useDataHealthMetrics(
  unitId: string | undefined
): DataHealthMetrics {
  const { reports, isLoading, hasEverLoaded } = useRolodexEntries(
    unitId
      ? {
          type: [RolodexEntryType.REPORT],
          tags: { unit: unitId },
        }
      : undefined
  )

  const categoryMetrics = useMemo(
    () => computeCategoryMetrics(reports),
    [reports]
  )

  const totalDocuments = useMemo(
    () => calculateTotalDocuments(categoryMetrics),
    [categoryMetrics]
  )

  return {
    categoryMetrics,
    totalDocuments,
    isLoading,
    hasEverLoaded,
  }
}
